export default "/wp-content/themes/custom-theme/dist/fonts/vendor/@mdi/materialdesignicons-webfont.ttf?1fcc36272ea3e53d0031fbfedffd88cc";